import dayjs from 'dayjs'
import React, { useContext } from 'react'
import { AppContext } from '../../../contexts/AppContext'

const OverviewBackground: React.FC = () => {
	const { isMobileView, isDarkMode } = useContext(AppContext)

	const backgrounds = {
		summer: {
			native: 'assets/native-background/vae_summer.jpg',
			browser: 'assets/browser-background/vae_summer.jpg',
		},
		autumn: {
			native: 'assets/native-background/vae_autumn.jpg',
			browser: 'assets/browser-background/vae_autumn.jpg',
		},
		winter: {
			native: 'assets/native-background/vae_winter.jpg',
			browser: 'assets/browser-background/vae_winter.jpg',
		},
		spring: {
			native: 'assets/native-background/vae_spring.jpg',
			browser: 'assets/browser-background/vae_spring.jpg',
		},
	}

	const month = dayjs().month() + 1 // dayjs months are 0-indexed
	let season: 'spring' | 'summer' | 'autumn' | 'winter'
	if (month >= 3 && month <= 5) {
		season = 'spring'
	} else if (month >= 6 && month <= 8) {
		season = 'summer'
	} else if (month >= 9 && month <= 11) {
		season = 'autumn'
	} else {
		season = 'winter'
	}

	const background = backgrounds[season][isMobileView ? 'native' : 'browser']

	const lightModeFilter = !isDarkMode
		? {
				filter: 'brightness(1.35) contrast(0.9) saturate(1.35) hue-rotate(10deg)',
			}
		: {}

	return (
		<img
			className={`top-0 right-0 left-0 absolute w-full shadow-md clip-background ${isMobileView ? 'aspect-square' : 'aspect-[1600/486]'}`}
			src={background}
			style={lightModeFilter}
		/>
	)
}

export default OverviewBackground
